export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmYUtfCBc4AMP6lbBP.7c4374ae.woff2";